import React from "react";
import PropTypes from "prop-types";
import "react-dropdown/style.css";
import Pagination from "react-js-pagination";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import Layout from "containers/Layout";
import ThemMoiCongViec from "components/CommonComponent/ThemMoiCongViec";
import GiaHanCongViec from "components/CommonComponent/GiaHanCongViec";
import GiaoChoNguoiKhac from "components/CommonComponent/GiaoChoNguoiKhac";
import DanhGiaCongViec from "components/CommonComponent/DanhGiaCongViec";
import ChiTietCongViec from "components/CommonComponent/ChiTietCongViec";
class QuanLyCongViec extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showThemMoiCongViec: false,
      showGiaHanCongViec: false,
      showGiaoChoNguoiKhac: false,
      showDanhGiaCongViec: false,
      showChiTietCongViec: false,
      dataSearch: {
        pageIndex: 1,
        pageSize: 20,
        ThoiGian: "",
      },
    };
  }

  loadQuanLyCongViec(dataSearch) {
    let { getListQuanLyCongViec } = this.props;
    getListQuanLyCongViec(dataSearch);
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  setModalThemMoiCongViecShow = () => {
    this.setState({
      showThemMoiCongViec: !this.state.showThemMoiCongViec,
    });
  };

  setModalGiaHanCongViecShow = () => {
    this.setState({
      showGiaHanCongViec: !this.state.showGiaHanCongViec,
    });
  };

  setModalGiaoChoNguoiKhacShow = () => {
    this.setState({
      showGiaoChoNguoiKhac: !this.state.showGiaoChoNguoiKhac,
    });
  };

  setModalDanhGiaCongViecShow = () => {
    this.setState({
      showDanhGiaCongViec: !this.state.showDanhGiaCongViec,
    });
  };

  setModalChiTietCongViecShow = () => {
    this.setState({
      showChiTietCongViec: !this.state.showChiTietCongViec,
    });
  };

  renderTableRows() {
    let List = [{ status: 0 }, { status: 1 }, { status: 2 }, { status: 3 }];
    return List.map((item, index) => (
      <div className="custom-table-row">
        <div className="custom-table-cell username-cell flex-basis-5 flex-basis-6-sm disk-mobile">
          <span className="mobile-column-name">STT</span>
          <div className="center-wrapper">
            <p className="text-center">1</p>
          </div>
        </div>

        <div className="custom-table-cell flex-basis-16 flex-basis-13-6-sm">
          <span className="mobile-column-name">Mã công việc</span>
          <div className="center-wrapper">
            <p className="text-center">
              <a
                href={() => false}
                className="blue btn-link"
                onClick={this.setModalChiTietCongViecShow}
              >
                CV201011-001
              </a>
            </p>
          </div>
        </div>

        <div className="custom-table-cell flex-basis-12 flex-basis-11-8-sm">
          <span className="mobile-column-name">Nhân viên</span>
          <div className="center-wrapper">
            <p>Nguyễn thị thu hằng</p>
          </div>
        </div>

        <div className="custom-table-cell flex-basis-11 flex-basis-12-sm">
          <span className="mobile-column-name">Tên công việc</span>
          <div className="center-wrapper">
            <p className="text-left">Đi đòi nợ thuê</p>
          </div>
        </div>

        <div className="custom-table-cell flex-basis-11 flex-basis-15-sm">
          <span className="mobile-column-name">Liên quan đến hợp đồng</span>
          <div className="center-wrapper">
            <p className="text-center">
              <a href={() => false} className="blue">
                LN201402-001
              </a>
            </p>
          </div>
        </div>

        <div className="custom-table-cell flex-basis-8 flex-basis-8-sm">
          <span className="mobile-column-name">Thời hạn</span>
          <div className="center-wrapper">
            <p className="text-center">
              07/10/2018
              <br />
              12/10/2018
            </p>
          </div>
        </div>

        <div className="custom-table-cell flex-basis-11 flex-basis-10-sm">
          <span className="mobile-column-name">Trạng thái</span>
          <div className="center-wrapper">
            <p className="text-center">
              {item.status === 0 && (
                <span className="dang-vay">Đang thực hiện</span>
              )}
              {item.status === 1 && <span className="dong">Kết thúc</span>}
              {item.status === 2 && (
                <span className="canh-bao-no">Đến hạn</span>
              )}
              {item.status === 3 && (
                <span className="canh-bao-red">Quá hạn</span>
              )}
            </p>
          </div>
        </div>

        <div className="custom-table-cell flex-basis-10 flex-basis-10-sm action-cell">
          <span className="mobile-column-name">Đánh giá</span>
          <div className="center-wrapper">
            {item.status === 0 && <p className="text-center">Chưa có</p>}
            {item.status === 1 && <p className="text-center">Hoàn thành</p>}
            {item.status === 2 && (
              <p className="text-center">Không hoàn thành</p>
            )}
          </div>
        </div>

        <div className="custom-table-cell flex-basis-16 flex-basis-13-6-sm  action-cell">
          <div className="center-wrapper">
            <div className="iconTableMormanCenter">
              <a href={() => false}>
                <PopoversBootrap
                  contentText="Sửa"
                  trigger={["hover", "focus"]}
                  placement={"top"}
                >
                  <i className="mdi mdi-pencil-circle"></i>
                </PopoversBootrap>
              </a>

              <a href={() => false} onClick={this.setModalGiaHanCongViecShow}>
                <PopoversBootrap
                  contentText="Gia hạn"
                  trigger={["hover", "focus"]}
                  placement={"top"}
                >
                  <i className="mdi mdi-clipboard-text-multiple-outline"></i>
                </PopoversBootrap>
              </a>

              <a href={() => false} onClick={this.setModalGiaoChoNguoiKhacShow}>
                <PopoversBootrap
                  contentText="Giao cho người khác"
                  trigger={["hover", "focus"]}
                  placement={"top"}
                >
                  <i className="mdi mdi-account-arrow-right"></i>
                </PopoversBootrap>
              </a>

              <a href={() => false} onClick={this.setModalDanhGiaCongViecShow}>
                <PopoversBootrap
                  contentText="Đánh giá"
                  trigger={["hover", "focus"]}
                  placement={"top"}
                >
                  <i className="mdi mdi-thumb-up"></i>
                </PopoversBootrap>
              </a>

              <a href={() => false}>
                <PopoversBootrap
                  contentText="Xoá"
                  trigger={["hover", "focus"]}
                  placement={"top"}
                >
                  <i className="mdi mdi-delete"></i>
                </PopoversBootrap>
              </a>
            </div>
          </div>
        </div>
      </div>
    ));
  }
  render() {
    let {
      dataSearch,
      showThemMoiCongViec,
      showGiaHanCongViec,
      showGiaoChoNguoiKhac,
      showDanhGiaCongViec,
      showChiTietCongViec,
    } = this.state;
    var TotalQuantity = 15;
    return (
      <Layout>
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div className="bg-icon-bredcrumb">
                          <i className="mdi mdi-account-multiple"></i>
                        </div>
                        <div className="media-body-home">
                          <h2 className="text-info-home">Quản lý công việc</h2>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="search-new hidden-mobile-main show-table-main">
                  <div className="input-sm-new input-new-18">
                    <input
                      type="text"
                      className="form-control input-sm"
                      placeholder="Tên nhân viên"
                    />
                  </div>

                  <div className="input-sm-new input-new-18">
                    <input
                      type="text"
                      className="form-control input-sm  datepicker-default"
                      placeholder="Từ ngày"
                    />
                  </div>

                  <div className="input-sm-new input-new-18">
                    <input
                      type="text"
                      className="form-control input-sm  datepicker-default"
                      placeholder="Đến ngày"
                    />
                  </div>

                  <div className="input-sm-new input-new-18 search-main-new">
                    <button type="submit" className="btn btn-info-new">
                      <i className="la la-search"></i>
                    </button>
                  </div>
                </div>

                <div className="repeater-default hide-table-main show-mobile-main hidden-des-main">
                  <div data-repeater-list="car">
                    <div data-repeater-item className="">
                      <form className="form row bg-search-form form-mobile-search">
                        <div className="mb-1 ">
                          <button
                            type="button"
                            className="btn btn-border-new"
                            onClick={this.setModalThemMoiCongViecShow}
                          >
                            <i className="mdi mdi-plus"></i> Thêm mới
                          </button>
                        </div>

                        <div className="text-right left-search search-p mb-1 ">
                          <div className="search-mobile-new">
                            <fieldset className="form-group position-relative mb-0">
                              <input
                                type="text"
                                className="form-control input-sm"
                                id="iconLeft1"
                                placeholder="Tên, mã, nhân viên ..."
                              />
                              <div className="form-control-position">
                                <i className="mdi mdi-magnify"></i>
                              </div>
                            </fieldset>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>

                <div className="iconbutton-new hidden-mobile-main show-table-main">
                  <div className="row">
                    <div className="col-sm-12 col-md-9">
                      <button
                        type="button"
                        className="btn btn-border-new"
                        onClick={this.setModalThemMoiCongViecShow}
                      >
                        <i className="mdi mdi-plus"></i> Thêm mới
                      </button>
                    </div>
                    <div className="col-sm-12 col-md-3 d-flex just-end"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="Left808x200 Table-main-new">
            <div className="table-mobile sticky-table-bh1 table-mobile-hover">
              <div className="custom-table-wrapper">
                <div className="table-headers">
                  <div className="custom-table-header flex-basis-5 flex-basis-6-sm">
                    <p className="text-center">
                      STT
                      <br /> <span className="red">[ 8 ]</span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-16 flex-basis-13-6-sm">
                    <p className="text-center">Mã công việc</p>
                  </div>
                  <div className="custom-table-header flex-basis-12 flex-basis-11-8-sm">
                    <p>Nhân viên</p>
                  </div>
                  <div className="custom-table-header flex-basis-11 flex-basis-12-sm">
                    <p className="text-left">Tên công việc</p>
                  </div>
                  <div className="custom-table-header flex-basis-11 flex-basis-15-sm">
                    <p className="text-center">Liên quan đến hợp đồng</p>
                  </div>
                  <div className="custom-table-header flex-basis-8 flex-basis-8-sm">
                    <p className="text-center">Thời hạn</p>
                  </div>
                  <div className="custom-table-header flex-basis-11 flex-basis-10-sm">
                    <p className="text-center">Trạng thái</p>
                  </div>
                  <div className="custom-table-header flex-basis-10 flex-basis-10-sm">
                    <p className="tab-header text-center">Đánh giá</p>
                  </div>
                  <div className="custom-table-header flex-basis-16 flex-basis-13-6-sm">
                    <p className="tab-header text-left">Chức năng</p>
                  </div>
                </div>

                <div className="custom-table-body">
                  {this.renderTableRows()}
                </div>
              </div>
            </div>
            <div
              className={
                "paniation-new paniation-new1 d-flex justify-content-center " +
                (TotalQuantity === 0 ? "hidden" : "")
              }
            >
              <nav aria-label="Page navigation">
                <Pagination
                  activePage={dataSearch.pageIndex}
                  itemsCountPerPage={dataSearch.pageSize}
                  totalItemsCount={TotalQuantity}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange}
                  itemClass="page-item"
                  linkClass="page-link"
                  activeClass="active"
                />
              </nav>
            </div>
          </div>
        </div>
        <ThemMoiCongViec
          show={showThemMoiCongViec}
          onHide={this.setModalThemMoiCongViecShow}
        ></ThemMoiCongViec>
        <GiaHanCongViec
          show={showGiaHanCongViec}
          onHide={this.setModalGiaHanCongViecShow}
        ></GiaHanCongViec>
        <GiaoChoNguoiKhac
          show={showGiaoChoNguoiKhac}
          onHide={this.setModalGiaoChoNguoiKhacShow}
        ></GiaoChoNguoiKhac>
        <DanhGiaCongViec
          show={showDanhGiaCongViec}
          onHide={this.setModalDanhGiaCongViecShow}
        ></DanhGiaCongViec>
        <ChiTietCongViec
          show={showChiTietCongViec}
          onHide={this.setModalChiTietCongViecShow}
        ></ChiTietCongViec>
      </Layout>
    );
  }
}

QuanLyCongViec.propTypes = {
  getList: PropTypes.func,
};

export default QuanLyCongViec;
